var map = {
	"./2018-03-04/whats-new.html": 1901,
	"./2018-04-12/whats-new.html": 1902,
	"./2018-04-24/whats-new.html": 1903,
	"./2018-05-23/whats-new.html": 1904,
	"./2018-05-31/whats-new.html": 1905,
	"./2018-07-04/whats-new.html": 1906,
	"./2018-07-19/whats-new.html": 1907,
	"./2018-11-20/whats-new.html": 1908,
	"./2019-04-04/whats-new.html": 1909,
	"./2020-01-21/whats-new.html": 1910,
	"./2020-07-18/whats-new.html": 1911
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1900;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update ^\.\/.*\/whats\-new\.html$
// module id = 1900
// module chunks = 0